<template>
  <div>
    <el-table :data="auditList" border height="calc(100vh - 360px)">
      <el-table-column label="订单id">
        <template slot-scope="scope">{{ scope.row.id }}</template>
      </el-table-column>
      <el-table-column prop="orderNo" label="平台订单号"></el-table-column>
      <el-table-column prop="userId" label="账号id"></el-table-column>
      <el-table-column prop="createTime" label="创建时间">
        <template slot-scope="scope">
          {{ scope.row.createTime | moment }}
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" label="修改时间">
        <template slot-scope="scope">
          {{ scope.row.updateTime | moment }}
        </template>
      </el-table-column>
      <el-table-column prop="orderAmount" label="下单金额"></el-table-column>
      <el-table-column label="下单币种">
        <template slot-scope="scope">{{ scope.row.ccyNo }}</template>
      </el-table-column>
      <el-table-column prop="amount" label="兑换金额"></el-table-column>
      <el-table-column prop="coin" label="兑换币种"></el-table-column>
      <el-table-column prop="price" label="兑换单价"></el-table-column>

      <el-table-column prop="fee" label="手续费"></el-table-column>
      <el-table-column prop="feeCoin" label="手续费币种"></el-table-column>
      <el-table-column prop="orderType" label="买卖方向">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.orderType == 'B'">买</el-tag>
          <el-tag type="danger" v-else>卖</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="payStatus" label="状态">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.payStatus == 0"
            >交易成功</el-tag
          >
          <el-tag v-if="scope.row.payStatus == 1">未确认</el-tag>
          <el-tag v-if="scope.row.payStatus == 2">确认中</el-tag>
          <el-tag v-if="scope.row.payStatus == 3">卖单待审批</el-tag>
          <el-tag v-if="scope.row.payStatus == 4">卖单审批通过</el-tag>
          <el-tag v-if="scope.row.payStatus == -2">审批不通过</el-tag>
          <el-tag v-if="scope.row.payStatus == -1">失败</el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="fromAccountOrAddress"
        label="from地址"
      ></el-table-column>
      <el-table-column prop="hash" label="hash"></el-table-column>
      <el-table-column label="to地址">
        <template slot-scope="scope">
          <a class="link" target="_blank">{{ scope.row.toAddress }}</a>
          <a
            class="link"
            target="_blank"
            @click="open(scope.row.coin, scope.row.toAddress, scope.row.hash)"
            >{{ scope.row.toAddress }}</a
          >
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="审核状态">
        <template slot-scope="scope">
          <el-tag :type="scope.row.__status.color">{{
            scope.row.__status.text
          }}</el-tag>
        </template>
      </el-table-column> -->
      <!-- <el-table-column prop="status" label="区块状态"></el-table-column> -->

      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            @click="goPass(scope.row.id)"
            v-if="scope.row.payStatus === 3"
            >审核通过</el-button
          >
          <el-button
            type="danger"
            size="small"
            @click="goNoPass(scope.row.id)"
            v-if="scope.row.payStatus === 3"
            >审核不通过</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :total="totalCount"
      :page="pagination.page"
      @pageChanged="handleCurrentChange"
    ></pagination>
  </div>
</template>

<script>
import Pagination from 'components/pagination'
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex'

export default {
  name: 'KYCAudit',
  data() {
    return {
      auditId: null,
    }
  },
  computed: {
    ...mapState('cashOut', ['pagination', 'totalCount', 'auditList']),
    ...mapGetters('cashOut', ['projectList']),
  },
  components: {
    Pagination,
  },
  methods: {
    ...mapActions('cashOut', ['list', 'setPass', 'pass', 'noPass']),
    ...mapMutations('cashOut', ['setpage']),
    handleCurrentChange(pagination) {
      this.setpage(pagination)
      this.$emit('refresh', { pagination })
    },
    cancelBlack(isPass, id) {
      const action = isPass
        ? this.$confirm('确定通过审核吗？', '提示', {
            type: 'warning',
          })
        : this.$confirm('确定审核不通过吗？', '提示', {
            type: 'warning',
          })
      action.then(({ value }) => {
        this.setPass({
          id: id,
          auditStatus: isPass ? 1 : 2,
        })
          .then(() => {
            this.$message({
              type: 'success',
              message: '操作成功！',
            })
          })
          .finally(() => {
            this.list({ page: 1 })
          })
      })
    },
    goPass(id) {
      this.pass({ id }).then((res) => {
        if (res.code == 0) {
          this.$message.success('审核通过')
          this.$emit('refresh', { pagination })
        }
      })
    },
    goNoPass(id) {
      this.noPass({ id }).then((res) => {
        if (res.code == 0) {
          this.$message.success('审核不通过')
          this.$emit('refresh', { pagination })
        }
      })
    },
    open(coin, toAddress, hash) {
      window.open(
        '#/home/audit/deposite/records?coin=' +
          coin +
          '&toAddress=' +
          toAddress +
          '&hash=' +
          hash
      )
    },
  },
}
</script>

<style lang="less" scoped>
.link {
  text-decoration: underline;
  cursor: pointer;
  color: #409eff;
}
</style>
